export default __webpack_public_path__ + "static/ec-97c82c43a7809b1d2df7dda8b5b00a4b.svg";